'use client';

import { useState } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { SERIF_FONT } from '@/theme';

/**
 * Lista de preguntas frecuentes con expand/collapse. Accesible (button +
 * aria-expanded + region). El schema FAQPage lo inyecta la página aparte.
 *
 * @param {{q:string,a:string}[]} items
 * @param {boolean} dark  sobre navy
 */
export default function FAQAccordion({ items = [], dark = true }) {
  const [open, setOpen] = useState(0);
  const line = dark ? 'rgba(194,161,92,0.25)' : '#e8e0d1';
  const qColor = dark ? '#f6f1e8' : '#1b2a44';
  const aColor = dark ? '#aeb8cc' : '#4a5164';

  return (
    <Box>
      {items.map((item, i) => {
        const isOpen = open === i;
        return (
          <Box
            key={i}
            sx={{
              borderTop: `1px solid ${line}`,
              '&:last-of-type': { borderBottom: `1px solid ${line}` },
            }}
          >
            <Box
              component="button"
              type="button"
              aria-expanded={isOpen}
              onClick={() => setOpen(isOpen ? -1 : i)}
              sx={{
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: 3,
                py: '24px',
                textAlign: 'left',
                color: qColor,
              }}
            >
              <Typography
                component="span"
                sx={{
                  fontFamily: SERIF_FONT,
                  fontSize: 'clamp(18px, 2vw, 22px)',
                  fontWeight: 500,
                }}
              >
                {item.q}
              </Typography>
              <Box
                component="span"
                aria-hidden="true"
                sx={{
                  flexShrink: 0,
                  color: 'primary.main',
                  fontSize: '22px',
                  lineHeight: 1,
                  transform: isOpen ? 'rotate(45deg)' : 'none',
                  transition: 'transform 0.25s ease',
                }}
              >
                +
              </Box>
            </Box>
            {isOpen && (
              <Typography
                sx={{
                  pb: '26px',
                  pr: { md: '48px' },
                  fontSize: '15px',
                  lineHeight: 1.75,
                  color: aColor,
                }}
              >
                {item.a}
              </Typography>
            )}
          </Box>
        );
      })}
    </Box>
  );
}
